<template>
  <div class="statistics">
    <div class="row">
      <div class="key">合贴标数：</div>
      <div class="val">{{ statistics.tag_num }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    checkedList: { type: Array },
  },
  computed: {
    statistics() {
      let total = {
        tag_num: 0,
      }
      this.checkedList.forEach(item => {
        total.tag_num += item.tag_num - 0
      })
      return total
    }
  },
  data() {
    return {
    };
  },
  methods: {
  }
}
</script>
<style lang='scss' scoped>
.row {
  display: flex;
  margin-bottom: 5px;
  color: #000;

  .key {
    width: 80px;
    margin-right: 10px
  }

  .val {
    color: #B4272D;
  }
}
</style>